import {
  Box,
} from '@mui/material';
import './CategorizingPrintPrompt.scss';
import PrintCard from '../../../common/print/PrintCard';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  promptCard: {},
  children: null,
  fontScale: null,
};

const CategorizingPrintPrompt = (props) => {
  const {
    promptCard,
    children,
    fontScale,
  } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <Box
      boxShadow={2}
      className='categorizing-activity-prompt-card'
    >
      <div className='prompt-detail'>
        <PrintCard
          {...promptCard}
          fontScale={fontScale}
        />
      </div>
      <div
        className='prompt-selected-response-cards'
      >
        {children}
      </div>
    </Box>
  );
};

export default CategorizingPrintPrompt;
